var _circle, _circle2, _circle3, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGoodDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFE9C1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 16,
    r: 2,
    fill: "#373A4D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 16,
    r: 2,
    fill: "#373A4D"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_1059_7696",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1992 22C11.1258 26.5645 15.1613 30 19.9992 30C24.8371 30 28.8726 26.5645 29.7991 22H28.2626C27.3631 25.7294 24.0047 28.5 19.9992 28.5C15.9936 28.5 12.6352 25.7294 11.7358 22H10.1992Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 22V21H8.97584L9.21921 22.1989L10.1992 22ZM29.7991 22L30.7792 22.1989L31.0225 21H29.7991V22ZM28.2626 22V21H27.4751L27.2904 21.7656L28.2626 22ZM11.7358 22L12.7079 21.7656L12.5233 21H11.7358V22ZM9.21921 22.1989C10.2385 27.2203 14.6763 31 19.9992 31V29C15.6462 29 12.013 25.9087 11.1792 21.8011L9.21921 22.1989ZM19.9992 31C25.3221 31 29.7599 27.2203 30.7792 22.1989L28.8191 21.8011C27.9853 25.9087 24.3521 29 19.9992 29V31ZM29.7991 21H28.2626V23H29.7991V21ZM19.9992 29.5C24.4773 29.5 28.2295 26.4025 29.2347 22.2344L27.2904 21.7656C26.4968 25.0562 23.5322 27.5 19.9992 27.5V29.5ZM10.7637 22.2344C11.7689 26.4025 15.5211 29.5 19.9992 29.5V27.5C16.4662 27.5 13.5015 25.0562 12.7079 21.7656L10.7637 22.2344ZM11.7358 21H10.1992V23H11.7358V21Z",
    fill: "#373A4D",
    mask: "url(#path-4-inside-1_1059_7696)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoodDefault);
export default __webpack_public_path__ + "static/media/ic_good_default.beccb24eb0a4d12a6ce1ef1378ac806b.svg";
export { ForwardRef as ReactComponent };